import BookingContainer from "../ui/booking/containers/AppContainer";
import AccountContainer from "../ui/account/containers/AppContainer";
import QuotationList from "../ui/account/components/QuotationList";
import Invoices from "../ui/account/components/InvoicesList";
import Documents from "../ui/account/components/Documents";
import BookingList from "../ui/account/components/BookingList"; 
import { createBrowserRouter } from "react-router-dom";
import i18n from "../i18n";
import moment from "moment-timezone";
import Home from "../ui/account/components/Home";
import AccountForm from "../ui/account/components/AccountForm";
import Followup from "../ui/followup/components/Followup";
import FromHikeToBookRedirect from "../ui/booking/components/FromHikeToBookRedirect";
import {RollbarTestError} from "../ui/shared/components/RollbarTestError";
import RollbarErrorHandler from "../ui/shared/components/RollbarErrorHandler";

function i18nLoader(locale) {
    moment.locale(locale);
    moment.tz.setDefault("Europe/Paris");
    return i18n.changeLanguage(locale);
}

const AppRouter = createBrowserRouter([
    {
        path: "/:locale/book",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        children: [
            {
                path: ":reference",
            },
            {
                path: "optimalle/:reference",
            },
        ],
        element: <BookingContainer />,
        errorElement: <RollbarErrorHandler />
    },

    {
        path: "/:locale/itineraires/:slug/book",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        element: <FromHikeToBookRedirect />,
        errorElement: <RollbarErrorHandler />
    },
    
    {
        path: "/:locale/account/reservation/:reference",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        children: [
            {
                path: "invoice/:invoiceId",
            },
        ],
        element: <AccountContainer Component={Followup} />,
        errorElement: <RollbarErrorHandler />
    },
    {
        path: "/:locale/account/dashboard",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        element: <AccountContainer Component={Home} />,
        errorElement: <RollbarErrorHandler />
    },
    {
        path: "/:locale/account/informations",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        element: <AccountContainer Component={AccountForm} />,
        errorElement: <RollbarErrorHandler />
    },
    {
        path: "/:locale/error",
        element: <RollbarTestError/>,
        errorElement: <RollbarErrorHandler />
    },
    {
        path: "/:locale/account/reservations",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        element: <AccountContainer Component={BookingList} />,
        errorElement: <RollbarErrorHandler />
    },
    {
        path: "/:locale/account/quotations",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        element: <AccountContainer Component={QuotationList} />,
        errorElement: <RollbarErrorHandler />
    },
    {
        path: "/:locale/account/invoices",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        element: <AccountContainer Component={Invoices} />,
        errorElement: <RollbarErrorHandler />
    },
    {
        path: "/:locale/account/documents",
        loader: ({ params }) => {
            if (params.locale) {
                return i18nLoader(params.locale);
            }
        },
        element: <AccountContainer Component={Documents} />,
        errorElement: <RollbarErrorHandler />
    }
]);

export default AppRouter;
